import React, { useState } from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../common/Header'
import { Outlet } from 'react-router-dom'

export default function DashboardLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  

    return (
        <>
            <div className="app-container">
                <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
                <div className="main-content">
                    <Header toggleSidebar={toggleSidebar} />
                    <Outlet /> 
                </div>
            </div>
        </>
    )
}
